


import React from "react";
import styled from "styled-components";
import webdevelopment from '../Assets/Azharpic2.jpg';

// Main wrapper for the page
const Wrap = styled.div`
width: 100%;
height: auto;
padding:0px;
margin:0px;
box-sizing: border-box;
background-color: #f9f9f9; /* Light background for better readability */
  }
`;

// Container for content
const PageWrapper = styled.div`
  max-width: 900px;
  width: 90%;
  margin: 20px auto;
  padding: 20px;
  line-height: 1.8;
  color: #333;
  font-size: 16px;
  box-sizing: border-box;

  @media (max-width: 1024px) {
    font-size: 15px;
    padding: 18px;
  }

  @media (max-width: 768px) {
    font-size: 14px;
    padding: 15px;
    line-height: 1.7;
  }

  @media (max-width: 480px) {
    font-size: 13px;
    padding: 12px;
    line-height: 1.6;
    text-align: center;
  }
`;

// Page Title
const Title = styled.h1`
  text-align: center;
  margin-bottom: 25px;
  font-size: 2rem;
  background: linear-gradient(90deg, #ff7e5f, #feb47b);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  @media (max-width: 768px) {
    font-size: 1.6rem;
  }

  @media (max-width: 480px) {
    font-size: 1.4rem;
  }
`;

// Responsive Image
const MobileAppImage = styled.img`
  width: 100%;
  height: auto;
  object-fit: cover;
  // border-radius: 10px;
  margin-bottom: 25px;

  @media (max-width: 1024px) {
    max-height: 320px;
  }

  @media (max-width: 768px) {
    max-height: 250px;
  }

  @media (max-width: 480px) {
    max-height: 200px;
    margin-bottom: 20px;
  }
`;

// Paragraph styling


export default function PrivacyPolicy() {
  return (
    <Wrap>
      <MobileAppImage src={webdevelopment} alt="Background" />
    <PageWrapper>
      <Title>Affiliate Disclosure</Title>
      <p>
        <b>Galaxy Of Discounts</b> is a participant in the Amazon Associates Program,
        an affiliate advertising program designed to provide a means for sites
        to earn advertising fees by linking to Amazon.com and its affiliated
        sites.
      </p>
      <p>
        This means when you click on our Amazon links and make a purchase, we
        may earn a small commission at no additional cost to you.
      </p>
      <p>
        We only recommend products that we believe add value to our readers.
        Your support through these purchases helps us continue providing
        updated deals and recommendations.
      </p>
    </PageWrapper>
    </Wrap>
  );
}






